/**
 * Коды событий ЖИЗНЕННОГО ЦИКЛА оборудования. Зеркало App\Enums\InventoryItemEventType.
 *
 * ЭТО НЕ InventoryLogType. Тот — технический журнал правок («кто какое поле поменял»),
 * этот — деловая история вещи («приняли, выдали, увезли, списали»). Обе ленты живут
 * во вкладке «История» одновременно и заменять друг друга не должны.
 *
 * Зеркало нужно интерфейсу ради собственных решений по типу события — цвет маркера,
 * порядок в будущих фильтрах. Текст строки берётся из ответа (поле label), а не отсюда:
 * словарь названий — часть смысла события, и вторая его копия расходится с первой ровно
 * тогда, когда на бэкенде добавляют новый тип, а этот фронт уже выкачен.
 */
export default class InventoryItemEventType {
    static RECEIVED = 'received';
    static ISSUED = 'issued';
    static RETURNED = 'returned';
    static HOLDER_CHANGED = 'holder_changed';
    static MOVED = 'moved';
    static MARKED_BROKEN = 'marked_broken';
    static FAULT_CLEARED = 'fault_cleared';
    static REPAIR_SENT = 'repair_sent';
    static REPAIR_RETURNED = 'repair_returned';
    static WRITTEN_OFF = 'written_off';
}
